import React, { useState, useEffect, useRef } from 'react';
import './assests/css/style.css';
import imgurl from './assests/images/imgurl';
import Slider from "react-slick";
import { Typography, Button, Link, Box } from '@mui/material';
import { useNavigate } from "react-router-dom";
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import Drawer from '@mui/material/Drawer';
import ArrowBackOutlinedIcon from '@mui/icons-material/ArrowBackOutlined';
import ArrowForwardOutlinedIcon from '@mui/icons-material/ArrowForwardOutlined';
import AlertComp from './Alert';
import LanguageSelector from './LanguageSelector';
import i18next from "i18next";
import ToggleButton from "@mui/material/ToggleButton";
import ToggleButtonGroup from "@mui/material/ToggleButtonGroup";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import HtmlContentMaster from "../src/utils/HtmlContentMaster";
import { useDispatch, useSelector } from 'react-redux';
import { setgender } from './Reducers/reducer';
import { serviceDown, trackEvent } from './utils/UtilityFunctions';
import Cookies from 'js-cookie';
import MobileHeader from './components/MobileHeader';
import { postApi } from './api/services';

function OnBoardingSlider() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [activeIndex, setActiveIndex] = useState(0);
  const [open, setOpen] = useState(false);
  const [femaleInfoModal, setFemaleInfoModal] = useState(false);
  const [consentchk, setconsentchk] = useState(false);
  const [alertopen, setalertopen] = useState(false);
  const [alertmsg, setalertmsg] = useState("Test");
  const [genderToggle, setGenderToggle] = useState("male");
  const [defaultGender, setDefaultGender] = useState(null)
  const [openDialog, setOpenDialog] = useState(false);
  const [privacyDrawer, setPrivacyDrawer] = React.useState(false);
  const [isMobile, setIsMobile] = useState(false);

  let sliderRef = useRef(null);

  const { Gender } = useSelector((state) => state.user.profile)

  useEffect(() => {
    if (!window.cordova) {
      let isMobile = /iPhone|iPod|iPad|Android/i.test(navigator.userAgent);
      if (!isMobile) {
        setIsMobile(false);
      } else {
        setIsMobile(true);
      }
    }
  }, [isMobile]);

  useEffect(() => {
    if(Cookies.get('gender')){
      setGenderToggle(Cookies.get('gender'))
    } else {
      if(Gender == ''){
        if(localStorage.getItem('temp_gender')){
          setGenderToggle(localStorage.getItem('temp_gender'))
        } else {
          setDefaultGender(localStorage.getItem('gender'))
        }
      } else {
        setDefaultGender(Gender)
      }  
    }
  }, [genderToggle, defaultGender])

  const next = async () => {
    try {
      if (activeIndex == 0) {
        if (consentchk) {
          sliderRef.slickNext();
        } else {
          setalertmsg("Please agree to our terms and conditions.");
          setalertopen(true);
          setTimeout(() => {
            setalertopen(false);
          }, 4000);
        }
      } else if (activeIndex == 1) {
        await trackEvent('consent_given', 'success', '', localStorage.getItem('phno'))  
        dispatch(setgender(defaultGender ? defaultGender : genderToggle))
        localStorage.setItem('gender', defaultGender ? defaultGender : genderToggle)
        // navigate("/taketest", { replace: true, state: "onboardingComplete" });
        if(localStorage.getItem("test_taken")){
          navigate('/taketest')
        } else {
          navigate('/tutorial')
        }
      } else {
        sliderRef.slickNext();
      }
    } catch(err) {
      console.log("err", err);  
    }
  };

  const previous = () => {
    if (activeIndex == 0) {
      // navigate('/loginpage', { replace: true })
    } else {
      sliderRef.slickPrev();
    }
  };

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    swipe: false,
    afterChange: (current) => setActiveIndex(current),
  };

  const toggleChckBox = async (e) => {
    try{
      setconsentchk(e.target.checked);
      let genderVal = ''
      if(defaultGender){
        genderVal = defaultGender.toUpperCase() == "MALE" ? "Male" : "Female"
      } else {
        genderVal = genderToggle.toUpperCase() == "MALE" ? "Male" : "Female"
      }
      updateTerms(e.target.checked, genderVal)
    } catch (err) {
      console.log("err", err);
      // await trackEvent('consent_given', 'fail', err, localStorage.getItem('phno'))  
    }
  }

  const updateTerms = async (val, genderVal) => {
    try {
      let params = {
        phone_number: localStorage.getItem("phno"),
        termsncondsconsent: val,
        gender: genderVal
      }
      console.log("update_terms_consent params", params);
      let res = await postApi('update_terms_consent', params)
      if(res){
        console.log("update_terms_consent res", res);
      }
    } catch (err) {
      console.log("err", err);
      serviceDown()
    }
  }

  // content
  const male = [
    {
      // title: i18next.t("Show your Hairline"), // English text = key
      description: i18next.t("If you have long hair, pull it back so the edges of where your scalp meets your forehead is clearly visible."),
    },
    {
      // title: i18next.t("Keep your Distance"),
      description: i18next.t("Hold the camera about 20 cm away from your head."),
    },
    {
      // title: i18next.t("Use Proper Lighting"),
      description: i18next.t("Make sure you are in a well-lit area."),
    },
    {
      // title: i18next.t("Remove Eyewear"),
      description: i18next.t("Take off glasses, scarves, bands, or anything that covers your scalp."),
    },
  ];

  const female = [
    {
      // title: i18next.t("Create a Center Part"), // English text = key
      description: i18next.t(
        "Use a comb to part your hair straight down the middle."
      ),
    },
    {
      // title: i18next.t("Keep Your Distance"),
      description: i18next.t(
        "Hold the camera about 20 cm away from your head."
      ),
    },
    {
      // title: i18next.t("Remove Accessories"),
      description: i18next.t(
        "Take off glasses, scarves, bands, or anything that covers your scalp."
      ),
    },
    {
      // title: i18next.t("Avoid Wet or Oily Hair"),
      description: i18next.t(
        "Your hair should be free of oil, gel, mousse, or any styling products that coat your scalp."
      ),
    },
    {
      // title: i18next.t("Use Proper Lighting"),
      description: i18next.t("Make sure you are in a well-lit area."),
    },
  ];

  const guidelines = defaultGender
    ? defaultGender.toUpperCase() == "MALE"
      ? male
      : female
    : genderToggle
    ? genderToggle.toUpperCase() == "MALE"
      ? male
      : female
    : "";

  const handleToggleChange = async (event, newAlignment) => {
    try{
      setGenderToggle(newAlignment === "female" ? "female" : "male");
      await trackEvent('gender', 'success', '', localStorage.getItem('phno'))  
    } catch (err) {
      console.log("err", err);
      await trackEvent('gender', 'fail', err, localStorage.getItem('phno'))  
    }
  };

  const handleEvent = async (event) => {
    try{
      await trackEvent(event, 'success', '', localStorage.getItem('phno'))  
    } catch(err) {
      console.log("err", err)  
      await trackEvent(event, 'fail', err, localStorage.getItem('phno'))   
    }  
  }

  const handleDrawer = (which, to) => {
    if (which === "privacy" && to === "open") {
      setPrivacyDrawer(true);
    } else if (which === "privacy" && to === "close") {
      setPrivacyDrawer(false);
    } else if (which === "terms" && to === "open") {
      setTermsDrawer(true);
    } else if (which === "terms" && to === "close") {
      setTermsDrawer(false);
    }
  };

  return (
    <div className="onboardingslider">
      <div className="slider-container">
        <Slider
          ref={(slider) => {
            sliderRef = slider;
          }}
          {...settings}
        >
          <div key={1}>
            <div className="sliderone">
              <div
                className={
                  defaultGender
                    ? defaultGender.toUpperCase() == "MALE"
                      ? "sliderOneBg silderCommonBg"
                      : "sliderOneBg female silderCommonBg"
                    : genderToggle
                    ? genderToggle.toUpperCase() == "MALE"
                      ? "sliderOneBg silderCommonBg"
                      : "sliderOneBg female silderCommonBg"
                    : ""
                }
                // className="sliderOneBg silderCommonBg"
              >
                <div
                  className={
                    window.cordova
                      ? "language-select-div"
                      : "language-select-div web"
                  }
                >
                  <LanguageSelector />
                  {isMobile && <MobileHeader showDrawer={true}/>}
                </div>
                <div>
                  <p>{i18next.t("Scroll for further instructions")}</p>
                </div>
              </div>

              <div className="slidertext">
                <div 
                 className={
                  defaultGender
                    ? defaultGender.toUpperCase() == "MALE"
                      ? "sliderSubText termssubtext"
                      : "sliderSubText femaleText termssubtext"
                    : genderToggle
                    ? genderToggle.toUpperCase() == "MALE"
                      ? "sliderSubText termssubtext"
                      : "sliderSubText femaleText termssubtext"
                    : ""
                }>
                  <Typography>
                    {defaultGender
                      ? defaultGender.toUpperCase() == "MALE"
                        ? i18next.t("To begin, please select your gender")
                        : i18next.t(
                            "Take 2 photos of your scalp to create your starting point!"
                          )
                      : genderToggle
                      ? genderToggle.toUpperCase() == "MALE"
                        ? i18next.t("To begin, please select your gender")
                        : i18next.t(
                            "Take 2 photos of your scalp to create your starting point!"
                          )
                      : ""}
                  </Typography>
                  {/* <Typography className="genderToggletext">
                    {i18next.t("Select your gender")}
                  </Typography> */}

                  <ToggleButtonGroup
                    exclusive
                    onChange={handleToggleChange}
                    aria-label="text alignment"
                    className="switchGenderToggle"
                    value={defaultGender ? defaultGender : genderToggle}
                    // disabled={defaultGender ? true : false}
                  >
                    <ToggleButton
                      value="male"
                      aria-label="left aligned"
                      className="toggleGenderbutton maleButton"
                    >
                      {i18next.t("Male")}
                    </ToggleButton>

                    <ToggleButton
                      value="female"
                      aria-label="centered"
                      className="toggleGenderbutton maleButton"
                    >
                      {i18next.t("Female")}
                    </ToggleButton>
                  </ToggleButtonGroup>

                  {
                    (
                      genderToggle?.toUpperCase() === "FEMALE" || 
                      defaultGender?.toUpperCase() === "FEMALE"
                    ) && 
                    <p className='womennote mt-10px mb-0'>
                      <span>
                        {i18next.t("Please Note:")}
                      </span>
                      {i18next.t(" All women can take the AI hair loss test. However, the anti-DHT medicines that we recommend are contraindicated for women of reproductive age and is only advised for those who are menopausal.")}
                    </p>
                  }

                  {/* Gender dialog modal */}
                  <Dialog
                    onClose={() => {
                      setOpenDialog(false);
                    }}
                    open={openDialog}
                    className="healthdialog1"
                    disableBackdropClick
                  >
                    <div className="closeBtnWrapper">
                      <HighlightOffIcon
                        onClick={() => {
                          setOpenDialog(false);
                        }}
                      />
                    </div>
                    <DialogContent className="femaleDialogcontent">
                      <DialogContentText className="femaleModaltext">
                        <span> {i18next.t("Note")} :</span>{" "}
                        {i18next.t(
                          "This assessment is currently available for men."
                        )}
                      </DialogContentText>
                    </DialogContent>
                  </Dialog>

                  <div className="mt-20px checkBoxTerms">
                    <FormControlLabel
                      className="formConsent"
                      control={
                        <Checkbox
                          checked={consentchk}
                          onChange={toggleChckBox}
                          // disabled={genderToggle === "female"}
                        />
                      }
                      label={
                        <>
                          {i18next.t("I agree to the")}{" "}
                          <Link
                            target="_blank"
                            className="linkText"
                            onClick={() => {
                              setOpen(true)
                              handleEvent('viewed_terms_of_use')
                            }}
                          >
                            {i18next.t("terms of use")}
                          </Link>
                          &nbsp; {i18next.t("and")} &nbsp;
                          <Link
                            target="_blank"
                            className="linkText"
                            onClick={() => {
                              handleDrawer("privacy", "open")
                              handleEvent('viewed_privacy_policy')
                            }}
                          >
                            {i18next.t("privacy policy.")}
                          </Link>
                        </>
                      }
                    />
                  </div>
                </div>
                <Button
                  variant="contained"
                  className={`commonButton mt-20px`}
                  onClick={next}
                  // disabled={genderToggle === "female"}
                >
                  {i18next.t("Next")}
                </Button>
              </div>
            </div>
          </div>
          <div key={2}>
            <div className="sliderone">
              <div
                className={
                  defaultGender
                    ? defaultGender.toUpperCase() == "MALE"
                      ? "sliderTwoBg silderCommonBg"
                      : "sliderTwoBg female silderCommonBg"
                    : genderToggle
                    ? genderToggle.toUpperCase() == "MALE"
                      ? "sliderTwoBg silderCommonBg"
                      : "sliderTwoBg female silderCommonBg"
                    : ""
                }
                // className="sliderTwoBg silderCommonBg"
              >
                <div
                  className={
                    window.cordova
                      ? "language-select-div"
                      : "language-select-div web"
                  }
                >
                  <LanguageSelector />
                  {isMobile && <MobileHeader showDrawer={true}/>}
                </div>
                <div>
                  <p>{i18next.t("How to Scan Your Hairline Correctly")}</p>
                  <Typography className="sliderSubPara">
                    {defaultGender
                      ? defaultGender.toUpperCase() == "MALE"
                        ? i18next.t("Let’s get ready to take 4 simple photos of your head. Just follow these steps:")
                        : i18next.t("Let’s get ready to take 2 simple photos of your head. Just follow these steps:")
                      : genderToggle
                      ? genderToggle.toUpperCase() == "MALE"
                        ? i18next.t("Let’s get ready to take 4 simple photos of your head. Just follow these steps:")
                        : i18next.t("Let’s get ready to take 2 simple photos of your head. Just follow these steps:")
                      : ""}
                    {/* <br></br> {i18next.t("for your hair analysis")} */}
                  </Typography>
                </div>
              </div>

              <div className="slidertext">
                <div
                  className={
                    defaultGender
                      ? defaultGender.toUpperCase() == "MALE"
                        ? "sliderSubText"
                        : "sliderSubText female"
                      : genderToggle
                      ? genderToggle.toUpperCase() == "MALE"
                        ? "sliderSubText"
                        : "sliderSubText female"
                      : ""
                  }
                >
                  <Box className="guidelines-container">
                    {guidelines.map((item, index) => (
                      <Box key={index} className="guideline-item">
                        <Typography variant="h6" className="guideline-title">
                          {index + 1}.
                          {/* . {item.description} */}
                        </Typography>
                        <Typography
                          variant="body2"
                          className="guideline-description"
                        >
                          {item.description}
                        </Typography>
                      </Box>
                    ))}
                  </Box>
                </div>
                <Button
                  variant="contained"
                  className="commonButton mt-20px"
                  onClick={next}
                >
                  {i18next.t("Next")}
                </Button>
              </div>
            </div>
          </div>
          {/* <div key={3}>
            <div className='sliderone'>
              <div className='sliderThreeBg silderCommonBg'>
                <div className='sliderthreetext'>
                  <div className='beforeaftertexts'>
                    <span className='beforeImage'>Before</span>
                    <span className='afterImage'>After</span>
                  </div>
                </div>
                <div>
                  <p className='slidethree-title'>Capture. Compare. Confidence.</p>
                </div>
              </div>

              <div className='slidertext'>

                <div className='sliderSubText termssubtext'>
                  <Typography>Monitor your hair progress effortlessly!</Typography>
                  <Typography>Regain confidence—track it visually!</Typography>
                </div>
                <Button variant="contained" className='commonButton mt-20px' onClick={next}>
                  Take &nbsp; <span>a</span> &nbsp; Test

                </Button>
              </div>
            </div>
          </div> */}
        </Slider>
        <div style={{ textAlign: "center" }} className="slidercontrol">
          {activeIndex === 0 ? (
            ""
          ) : (
            <button className="button slideprev" onClick={previous}>
              <div className="sliderbtn1">
                <ArrowBackOutlinedIcon></ArrowBackOutlinedIcon>
              </div>
            </button>
          )}
          {/* <Typography>Prev</Typography> */}

          <button className="button slidefwd" onClick={next}>
            <div className="sliderbtn2">
              <ArrowForwardOutlinedIcon></ArrowForwardOutlinedIcon>
              {/* <Typography>Next</Typography> */}
              {/* <img src={imgurl.right_arrow} alt="Stack Logo" /> */}
            </div>
          </button>
        </div>
        <Drawer
          className="imguplddrwr trmscnddrwr"
          anchor={"bottom"}
          open={open}
          onClose={() => setOpen(false)}
        >
          <div className="drawerhead">
            <p></p>
            <div className="ellipse cursor-pointer" onClick={() => setOpen(false)}>
              <p>X</p>
            </div>
          </div>

          <div className="WordSection1">
            <h1>{i18next.t("Terms of Use")}</h1>

            <p className="MsoNormal">
              {i18next.t("Effective Date: 1 Jan, 2025")}
            </p>

            <h2>{i18next.t("Welcome")}</h2>

            <p className="MsoNormal">
              {i18next.t(
                "Welcome to the Alopexia website and application! These Terms of Use (“Terms”) govern your use of the services (“Service”) provided by Centa Bio (“us,” “we,” or “our”). By accessing or using the Alopexia website and/or application, you agree to be bound by these Terms."
              )}{" "}
              <br></br>
              <br></br>
            </p>

            <p className="MsoNormal">
              {i18next.t(
                "If you disagree with any part of these Terms, you may not access the Service."
              )}
            </p>

            <h2>{i18next.t("1. Use of the Service")}</h2>

            <p className="MsoNormal">
              {i18next.t(
                "Alopexia offers AI-driven personalized haircare solutions, including scalp analysis, treatment recommendations, and progress tracking. The Service is designed to provide actionable insights and personalized treatment options for users experiencing hair loss."
              )}
              <br></br>
              <br></br>
              {i18next.t("By using the Service, you agree to:")}
              <br></br>- {i18next.t("Use the Service only")}
              {i18next.t("for personal, non-commercial purposes.")}
              <br></br>- {i18next.t("Follow all")}
              {i18next.t(
                "applicable laws and regulations in your use of the Service."
              )}
            </p>

            <h2>{i18next.t("2. Eligibility")}</h2>

            <p className="MsoNormal">
              {i18next.t(
                "You must be at least 18 years old and a male to use the Service and capable of entering into a lawful agreement. By using the Service, you confirm that you meet these eligibility criteria."
              )}
            </p>

            <h2>{i18next.t("3. Account Creation")}</h2>

            <p className="MsoNormal">
              {i18next.t(
                "Certain features may require you to create an account. You agree to:"
              )}
              <br></br>-{" "}
              {i18next.t(
                "Provide accurate and up-to-date information during registration."
              )}
              <br></br>-{" "}
              {i18next.t(
                "Maintain the confidentiality of your account credentials."
              )}
              <br></br>-{" "}
              {i18next.t(
                "Notify us immediately of any unauthorized access to your account."
              )}
              <br></br>
              <br></br>
              {i18next.t(
                "You are solely responsible for activities under your account."
              )}
            </p>

            <h2>{i18next.t("4. Acceptable Use")}</h2>

            <p className="MsoNormal">
              {i18next.t("When using the Service, you agree not to:")}
              <br></br>-{" "}
              {i18next.t(
                "Interfere with or disrupt the functionality of the Service."
              )}
              <br></br>-{" "}
              {i18next.t(
                "Use the Service for illegal or unauthorized purposes."
              )}
              <br></br>-{" "}
              {i18next.t(
                "Upload harmful content, such as viruses, worms, or other malicious software."
              )}
              <br></br>-{" "}
              {i18next.t(
                "Engage in any activity that compromises the security or integrity of the Service."
              )}
            </p>

            <h2>{i18next.t("5. Intellectual Property Rights")}</h2>

            <p className="MsoNormal">
              {i18next.t(
                "All content, features, and functionality of the Service are the exclusive property of Centa Bio."
              )}{" "}
              <br></br>
              {i18next.t(
                "Unauthorized use of trademarks, logos, or proprietary materials is prohibited without prior written consent."
              )}
            </p>

            <h2>{i18next.t("6. Privacy")}</h2>

            <p className="MsoNormal">
              {i18next.t(
                "Your use of the Service is governed by our Privacy Policy, which outlines how we collect, use, and protect your personal information, including sensitive health data. Please review our Privacy Policy for more details."
              )}
            </p>

            <h2>{i18next.t("7. Data Usage and Sharing")}</h2>

            <p className="MsoNormal">
              {i18next.t("By using the Service, you agree to:")}
              <br></br>-{" "}
              {i18next.t(
                "Allow Centa Bio to collect and process data, including health-related data, to deliver personalized solutions."
              )}
              <br></br>-{" "}
              {i18next.t(
                "Consent to data aggregation for research and service improvement."
              )}
              <br></br>-{" "}
              {i18next.t(
                "Understand that we will not share your personally identifiable information without your explicit consent, except as required by law."
              )}
            </p>

            <h2>{i18next.t("8. Disclaimer of Warranties")}</h2>

            <p className="MsoNormal">
              {i18next.t(
                "The Service is provided on an “as is” and “as available” basis. Centa Bio does not guarantee uninterrupted access, error-free functionality, or the accuracy of the results generated by the AI-driven analysis."
              )}
            </p>

            <h2>{i18next.t("9. Limitation of Liability")}</h2>

            <p className="MsoNormal">
              {i18next.t(
                "To the fullest extent permitted by law, Centa Bio shall not be liable for:"
              )}
              <br></br>-{" "}
              {i18next.t("Indirect, incidental, or consequential damages.")}
              <br></br>-{" "}
              {i18next.t(
                "Loss of data, profits, or goodwill arising from your use of the Service."
              )}
            </p>

            <h2>{i18next.t("10. Changes to the Terms of Use")}</h2>

            <p className="MsoNormal">
              {i18next.t(
                "We reserve the right to update these Terms at any time. Any changes will be posted on this page, with the updated effective date. Continued use of the Service constitutes acceptance of the revised Terms."
              )}
            </p>

            <h2>{i18next.t("11. Governing Law")}</h2>

            <p className="MsoNormal">
              {i18next.t(
                "These Terms shall be governed by and construed in accordance with the laws of [Insert Governing Jurisdiction], without regard to its conflict of law principles."
              )}
            </p>

            <h2>{i18next.t("12. Contact Us")}</h2>

            <p className="MsoNormal">
              {i18next.t(
                "For questions or concerns regarding these Terms, please contact us at:"
              )}
              <br></br>- {i18next.t("Email")}: contact@aloxa.ai
              <br></br>- {i18next.t("Address")}: Centa Biotech SL,Alameda
              Principal 11,9001 Malaga, Spain.
              <br></br>
              {i18next.t(
                "By accessing or using the Alopexia website and application, you acknowledge that you have read, understood, and agree to these Terms of Use."
              )}
            </p>
          </div>
        </Drawer>
      </div>
      <AlertComp open={alertopen} msg={alertmsg} type={"error"} />
      <Drawer
        className="privacypolicydrawer"
        anchor={"bottom"}
        open={privacyDrawer}
        onClose={() => handleDrawer("privacy", "close")}
      >
        <div className="drawerhead">
          <div
            className="ellipse cursor-pointer"
            onClick={() => handleDrawer("privacy", "close")}
          >
            <p>X</p>
          </div>
        </div>
        <HtmlContentMaster keyName={"privacypolicy"} />
      </Drawer>
    </div>
  );
}

export default OnBoardingSlider